module.exports = __webpack_public_path__ + "static/larrys-95e0bfbda6726bca6a71a38dcebdec47.png";